module.exports = __webpack_public_path__ + "media/45.73faab05.mp3";